
import { mapMutations, mapGetters } from "vuex";
import TokenService from "@/services/tokenService";
import { defineComponent } from "vue";
import common from "@/config/common";
import messages from "@/config/messages";
import routesPath from "@/config/routesPath";
import * as apiClient from "@/apiclient/";

export default defineComponent({
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      countDown: common.logoutCountDown,
      idleTimer: 0,
    };
  },
  watch: {
    visible() {
      if (this.visible) {
        this.startCountDown();
      }
    },
  },
  computed: {
    ...mapGetters(["getFormDirty"]),
    formatCountdown() {
      const minutes = Math.floor(this.countDown / 60);
      const seconds = this.countDown % 60;
      const unit = this.countDown > 60 ? "m" : "s";
      return `${minutes}:${seconds < 10 ? "0" : ""}${seconds} ${unit}`;
    },
  },
  methods: {
    ...mapMutations([
      "setLogoutModal",
      "setLogoutTimer",
      "setClearTheInterval",
      "setFormDirty",
      "setAutoLogoutMsg",
    ]),
    startCountDown() {
      this.countDown = common.logoutCountDown;
      this.idleTimer = window.setInterval(() => {
        if (this.countDown > 0) {
          this.countDown -= 1;
        } else {
          this.setAutoLogoutMsg(messages.autoLogoutMsg);
          this.logout();
        }
      }, 1000);
    },
    closeModal() {
      clearInterval(this.idleTimer);
      this.setLogoutModal(false);
      this.setLogoutTimer();
    },
    async logout() {
      clearInterval(this.idleTimer);
      TokenService.logout();
      this.setClearTheInterval();
      this.setLogoutModal(false);
      this.setFormDirty(false);
      this.$router.push({ name: routesPath.getStarted });
    },
  },
});
